// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"dbcc403d","787":"dbcc403d","1982":"dbcc403d","3584":"dbcc403d"}[chunkId] + ".chunk.css";
};